import { forwardRef, useImperativeHandle, useRef } from 'react';

import {
  ContentWrapper,
  Content,
} from '@web/components/SearchContentPreview/searchContentPreview.styles';
import {
  usePreviewMask,
  usePreviewOffsetTop,
} from '@web/components/SearchContentPreview/searchContentPreview.hooks';

type Props = {
  isFixedHeight?: boolean;
  isPreview: boolean;
  parsedContent: {
    __html: string;
  };
  previewHeight?: number;
};

export type ForwardedAttrs = {
  maskEnabled: boolean;
};

const DEFAULT_PREVIEW_HEIGHT = 60;

export const SearchContentPreview = forwardRef<ForwardedAttrs, Props>((props, ref) => {
  const { isFixedHeight, isPreview, parsedContent, previewHeight = DEFAULT_PREVIEW_HEIGHT } = props;
  const contentRef = useRef<HTMLDivElement>();
  const { maskEnabled, contentHeight } = usePreviewMask(isPreview, contentRef, previewHeight);
  const { offsetTop } = usePreviewOffsetTop(isPreview, contentRef);
  const actualWrapperHeight =
    isFixedHeight && isPreview && maskEnabled ? previewHeight : contentHeight;

  useImperativeHandle(ref, () => ({
    maskEnabled,
  }));

  return (
    <ContentWrapper maskEnabled={maskEnabled} contentHeight={actualWrapperHeight}>
      <Content offsetTop={offsetTop} ref={contentRef} dangerouslySetInnerHTML={parsedContent} />
    </ContentWrapper>
  );
});

SearchContentPreview.displayName = 'SearchContentPreview';
